<h2 mat-dialog-title class="text-xl font-semibold text-gray-900 mb-2">Remove Parking Space from Group</h2>

<div mat-dialog-content class="space-y-4">
    <div class="bg-orange-50 border border-orange-200 rounded p-4">
        <p class="text-sm text-orange-800">
            Are you sure you want to remove <strong>{{ parkingSpaceName }}</strong> from the group <strong>{{ group.name
                }}</strong>?
        </p>
        <p class="text-xs text-orange-700 mt-1">
            Operators in this group will lose access to this parking space.
        </p>
    </div>

    @if (isRemoving()) {
    <div class="flex items-center gap-2 text-gray-600 text-sm">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Removing parking space...</span>
    </div>
    }
</div>

<div mat-dialog-actions class="flex gap-3 pt-4">
    <button mat-button (click)="onCancel()" [disabled]="isRemoving()" class="flex-1">Cancel</button>
    <button mat-raised-button color="warn" (click)="onConfirm()" [disabled]="isRemoving()" class="flex-1">
        @if (!isRemoving()) { Remove } @else { Removing... }
    </button>
</div>